import React, { useState, useEffect, useRef } from "react"
import { AcknoledgementStatementContainer, Close, EnterButton } from "./style"
import { ReactComponent as Logo } from "images/icons/canberra-logo.svg"
import { MainColumn } from "components/MainColumn"
import { ReactComponent as Cross } from "images/icons/cross.svg"
import { useEscHandler } from "utils/helpers/useEscHandler"
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock"
import moth from "icons/moth.png"

const AcknoledgementStatement = () => {
  const [shown, setShown] = useState(false)
  const popUpRef = useRef(null)

  const getCookie = name => {
    var nameEQ = name + "="
    var ca = document.cookie.split(";")
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == " ") c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  const closeStatement = () => {
    setShown(false)
    //setCookie
    var now = new Date()
    var time = now.getTime()
    time += 1000 * 60 * 60 * 24 * 30
    //milliseconds * seconds * mins * hours * days
    now.setTime(time)
    document.cookie =
      "acknowledgementShown=" +
      "true" +
      "; expires=" +
      now.toUTCString() +
      "; path=/"
  }
  useEscHandler(() => closeStatement())

  useEffect(() => {
    //show if no cookie
    const shownRecently = getCookie("acknowledgementShown")
    if (!shownRecently) {
      setShown(true)
    }
  }, [])

  useEffect(() => {
    //lock body
    const targetElement = popUpRef.current

    if (shown) {
      disableBodyScroll(targetElement)
    } else {
      enableBodyScroll(targetElement)
    }
  }, [shown])

  return (
    <AcknoledgementStatementContainer shown={shown} ref={popUpRef}>
      <Close onClick={() => closeStatement()}>
        <Cross />
      </Close>
      <MainColumn>
        <img src={moth} className="moth" />
        <p>
          We acknowledge the Traditional Custodians of the ACT, the Ngunnawal
          people.
        </p>
        <p>
          We acknowledge and respect their continuing culture and the
          contribution they make to the life of this city and this region.
        </p>

        <Logo className="logo" />
        <EnterButton label="Enter website" onClick={() => closeStatement()} />
      </MainColumn>
    </AcknoledgementStatementContainer>
  )
}

export default AcknoledgementStatement
